module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/firms/firms-edit/firms-edit.component.scss
// module id = ./src/app/routes/firms/firms-edit/firms-edit.component.scss
// module chunks = 9